import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import { useNavigate } from 'react-router-dom';
import useStateRef from "react-usestateref";
import { FormControl, Spinner } from "native-base";
import './index.css';
import "react-datepicker/dist/react-datepicker.css";
import { TextboxCustom } from 'src/components/TextboxCustom';
import EventEmitter from 'src/utils/EventEmitter';
import { LoadingView } from 'src/components/LoadingView';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { CloseSnackbarAction } from 'src/components/CloseSnackbarAction';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

import GooglePlacesAutocomplete, { geocodeByAddress } from 'react-google-places-autocomplete';
import PlaceIcon from '@mui/icons-material/Place';
import { regionList } from 'src/components/RegionList';
import { Select, MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  select: {
    '&.MuiInputBase-root': {
      height: "40px",
      fontSize: "14px",
      borderRadius: "4px",
      backgroundColor: "white",
      color: "#373940",
    },
    '&.MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#DADEE3 !important'
    },
    '&.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      boxShadow: "rgb(181, 183, 186) 0px 0px 0px 1px"
    },
    '&.MuiButtonBase-root.Mui-selected': {
      borderColor: 'rgba(80, 164, 83, 0.1)'
    }
  },
  menu_style: {
    "& li": {
      fontSize: 14,
      fontWeight: "400",
      color: "#202020",
      letterSpacing: "-0.02em",
      fontFamily: "Inter"
    },
    "& li:hover": {
      backgroundColor: '#bbdfbe'
    },
    "& li.Mui-selected:not(.Mui-disabled)": {
      backgroundColor: '#50A453',
      color: 'white'
    },
    "& li.Mui-selected:hover": {
      backgroundColor: '#50A453',
      color: 'white'
    },
  },
  select_error: {
    '&.MuiInputBase-root': {
      background: "rgba(255, 44, 39, 0.1)"
    },
    '&.MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF2C27 !important'
    },
    '&.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#b5b7ba !important'
    },
  },
}))

const EmailVerificationView = () => {
  /* eslint-disable */
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const classes = useStyles();

  const [userData, setUserData, userDataRef] = useStateRef({
    entity_name: '', trading_name: '', abn: '', primary_contact_name: '',
    primary_contact_email: '', primary_contact_phone: '', lead_pharmacist_ahpra_number: '', ahpra_registration_certificate: '', billing_contact_name: '', billing_contact_phone: '', billing_contact_email: '',
    are_you_a_compounding_pharmacy: 0, what_type_of_pharmacy_are_you: '', what_is_your_pharmacies_exposure_to_medical_cannabis: '',
    email: ''
  });
  const [signInLoading, setSignInLoading, signInLoadingRef] = useStateRef(false);
  const [error, setError, errorRef] = useStateRef({
    entity_name: false, trading_name: false, abn: false, dispensary_address: false, primary_contact_name: false,
    primary_contact_email: false, primary_contact_phone: false, lead_pharmacist_ahpra_number: false, ahpra_registration_certificate: false,
    billing_contact_name: false, billing_contact_phone: false, billing_contact_email: false, billing_contact_email_format: false,
    are_you_a_compounding_pharmacy: false, what_type_of_pharmacy_are_you: false, what_is_your_pharmacies_exposure_to_medical_cannabis: false,
    emailFormat: false, error_message: false
  });
  const [emailVerificationFlag, setEmailVerificationFlag, emailVerificationFlagRef] = useStateRef(1);

  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading, loadingRef] = useStateRef(false);
  const [isInvalid, setIsInvalid, isInvalidRef] = useStateRef(false)
  const [email, setEmail, emailRef] = useStateRef('');

  const [resendEmailLoading, setResendEmailLoading, resendEmailLoadingRef] = useStateRef(false);
  const [isResendSuccess, setIsResendSuccess, isResendSuccessRef] = useStateRef(false);

  const [errorMessage, setErrorMessage, errorMessageRef] = useStateRef('');
  const [accessToken, setAccessToken, accessTokenRef] = useStateRef(null);
  const [accessTokenLogin, setAccessTokenLogin, accessTokenLoginRef] = useStateRef(null);

  const [inputAddressValue, setInputAddressValue, inputAddressValueRef] = useStateRef('');
  const [selectedAddressValue, setSelectedAddressValue, selectedAddressValueRef] = useStateRef('');
  const [selectedDispensaryAddress, setSelectedDispensaryAddress, selectedDispensaryAddressRef] = useStateRef({
    Address: '',
    Address2: '',
    City: '',
    State: '',
    Zip: ''
  });
  const [selectedFile, setselectedFile, selectedFileRef] = useStateRef('');
  const pharmacyTypes = ["Independent owner", "Franchise Group (IE: Chemist Warehouse)", "Pharmacy Chain (<5 Locations)", "Other (please specify)"];
  const pharmacyExposure = ["New with limited knowledgable", "Somewhat knowledgable", "Experienced", "Very experienced"];
  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      setLoading(true);
      getData();
    }
  }, []);

  useEffect(() => {
    const onClickPrevStep = () => {
      onClickBackArrow();
    }

    const listener = EventEmitter.addListener('prev_step', onClickPrevStep);

    return () => {
      listener.remove();
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  const getData = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const token = urlParams.get('token');
    setAccessToken(token);

    if (token) {
      try {
        await axios.get(`/csapi/greenship/users/verify-token?token=${token}`, {},
          {}).then(async response => {
            if (response.data) {
              if (!response.data.user) {
                setIsInvalid(true);
              } else {
                if (response.data.userActive) {
                  enqueueSnackbar("Your account has been created", { variant: 'success', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });
                  navigate('/sign-in')
                  EventEmitter.emit("show_top_navigation", { value: false });

                } else {
                  if (!response.data.token) {
                    setIsInvalid(true);
                  } else {
                    if (response.data.email) {
                      setUserData({ ...userDataRef.current, primary_contact_email: response.data.email })
                    }
                  }
                }
              }
            }
          })
      } catch (e) {
        navigate('/sign-in')
        EventEmitter.emit("show_top_navigation", { value: false });
        var error_message = e.response ? e.response.data ? e.response.data ? e.response.data.Message : e.response.data : e.response.statusText : e.message;

        enqueueSnackbar(error_message, { variant: 'error', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });
      }
    } else {
      setIsInvalid(true);
    }

    setLoading(false);
  }

  const onChange = (e, type) => {
    var value = e;
    if (type === "what_type_of_pharmacy_are_you" || type === "what_is_your_pharmacies_exposure_to_medical_cannabis") {
      value = e.target.value;
    }

    setUserData({ ...userDataRef.current, [type]: value });
    if (value) {
      setError({ ...errorRef.current, [type]: false })
    }

    if (type === "billing_contact_email") {
      setError({ ...errorRef.current, billing_contact_email_format: false })
    }

  }

  const onClickBackArrow = () => {
    if (!signInLoadingRef.current) {
      if (emailVerificationFlagRef.current === 1) {
        backToLogin();
      } else if (emailVerificationFlagRef.current === 2) {
        setEmailVerificationFlag(1);
      } else if (emailVerificationFlagRef.current === 3) {
        setError({ ...errorRef.current, experience: false });
        setEmailVerificationFlag(2);
      }
    }
  }

  const onSubmit = () => {
    if (!signInLoadingRef.current) {
      if (emailVerificationFlagRef.current === 1) {
        var isVerified = false;

        if (selectedDispensaryAddressRef.current.Address && userDataRef.current.entity_name && userDataRef.current.trading_name && userDataRef.current.abn && userDataRef.current.primary_contact_name) {
          isVerified = true;
        } else {
          isVerified = false;
          if (!userDataRef.current.entity_name) { setError({ ...errorRef.current, entity_name: true }) }
          if (!userDataRef.current.trading_name) { setError({ ...errorRef.current, trading_name: true }) }
          if (!userDataRef.current.abn) { setError({ ...errorRef.current, abn: true }) }
          if (!userDataRef.current.primary_contact_name) { setError({ ...errorRef.current, primary_contact_name: true }) }
          if (!selectedDispensaryAddressRef.current.Address) { setError({ ...errorRef.current, dispensary_address: true }) }
        }

        if (isVerified) {
          setEmailVerificationFlag(2);
        }

      } else if (emailVerificationFlagRef.current === 2) {
        var isVerified_2 = false;

        if (userDataRef.current.primary_contact_email && userDataRef.current.primary_contact_phone && userDataRef.current.lead_pharmacist_ahpra_number && selectedFileRef.current
          && userDataRef.current.billing_contact_name && userDataRef.current.billing_contact_phone && userDataRef.current.billing_contact_email) {
          isVerified_2 = true;
        } else {
          isVerified_2 = false;
          if (!userDataRef.current.primary_contact_email) { setError({ ...errorRef.current, primary_contact_email: true }) }
          if (!userDataRef.current.primary_contact_phone) { setError({ ...errorRef.current, primary_contact_phone: true }) }
          if (!userDataRef.current.lead_pharmacist_ahpra_number) { setError({ ...errorRef.current, lead_pharmacist_ahpra_number: true }) }
          if (!selectedFileRef.current) { setError({ ...errorRef.current, ahpra_registration_certificate: true }) }
          if (!userDataRef.current.billing_contact_name) { setError({ ...errorRef.current, billing_contact_name: true }) }
          if (!userDataRef.current.billing_contact_phone) { setError({ ...errorRef.current, billing_contact_phone: true }) }
          if (!userDataRef.current.billing_contact_email) { setError({ ...errorRef.current, billing_contact_email: true }) }
        }

        checkEmailFormat();

        if (errorRef.current.billing_contact_email_format) {
          isVerified_2 = false;
        }

        if (isVerified_2) {
          setEmailVerificationFlag(3);
        }

      } else if (emailVerificationFlagRef.current === 3) {
        var isVerified_3 = false;

        if (userDataRef.current.are_you_a_compounding_pharmacy && userDataRef.current.what_type_of_pharmacy_are_you && userDataRef.current.what_is_your_pharmacies_exposure_to_medical_cannabis) {
          isVerified_3 = true;
        } else {
          isVerified_3 = false;
          if (!userDataRef.current.are_you_a_compounding_pharmacy) { setError({ ...errorRef.current, are_you_a_compounding_pharmacy: true }) }
          if (!userDataRef.current.what_type_of_pharmacy_are_you) { setError({ ...errorRef.current, what_type_of_pharmacy_are_you: true }) }
          if (!userDataRef.current.what_is_your_pharmacies_exposure_to_medical_cannabis) { setError({ ...errorRef.current, what_is_your_pharmacies_exposure_to_medical_cannabis: true }) }

        }

        if (isVerified_3) {
          onVerificationEmail();
        }

      } else if (emailVerificationFlagRef.current === 4) {
        authenticateUser();
      }
    }
  }

  const onVerificationEmail = async () => {
    setSignInLoading(true);
    var user_data = userDataRef.current;
    var address = selectedDispensaryAddressRef.current;
    var name = user_data.trading_name;
    var first_name = user_data.trading_name;
    var last_name = "";

    if (name.split(" ").length > 1) {
      first_name = name.split(' ').slice(0, -1).join(' ')
      last_name = name.split(' ').slice(-1).join(' ')
    }

    var body = {
      FirstName: first_name,
      LastName: last_name,
      Name: name,
      Company: user_data.entity_name,
      AccessUser_Primary_Contact_Name: user_data.primary_contact_name,
      AccessUser_ABN_Number: user_data.abn,
      Phone: user_data.primary_contact_phone,
      AccessUser_AccessUser_AHPRA_Number: user_data.lead_pharmacist_ahpra_number,
      AccessUser_AHPRA_Registration_Certificate: '',
      AccessUser_Billing_Name: user_data.billing_contact_name,
      AccessUser_Billing_Phone: user_data.billing_contact_phone,
      AccessUser_Billing_Email: user_data.billing_contact_email,
      CompoundingPharmacies: user_data.are_you_a_compounding_pharmacy,
      AccessUser_Pharmacy_Type: user_data.what_type_of_pharmacy_are_you,
      AccessUser_Pharmacies_Exposure: user_data.what_is_your_pharmacies_exposure_to_medical_cannabis,
      Address: address.Address,
      Address2: address.Address2,
      City: address.City,
      State: address.State,
      Zip: address.Zip,
      Country: "Australia"
    }

    try {
      await axios.post(`/csapi/greenship/users/activate-account?token=${accessTokenRef.current}`, body, {})
        .then(async (response) => {
          if (response.data) {
            if (response.data.Token) {
              setAccessTokenLogin(response.data.Token);
            }

            try {
              const formData = new FormData();
              formData.append("file", selectedFileRef.current, selectedFileRef.current.name);

              var certificate_location = "";

              await axios({
                method: "post",
                url: "/csapi/files",
                data: formData,
                headers: { "Content-Type": "multipart/form-data", "Authorization": `Bearer ${response.data.Token}` },
              }).then(async response => {
                if (response.data) {
                  if (response.data.Data) {
                    if (response.data.Data.Location) {
                      certificate_location = response.data.Data.Location;
                    }
                  }
                }
              })

              if (certificate_location) {
                await axios.patch(`/csapi/users/info?UserCustomFields=none`,
                  {
                    "AccessUser_AHPRA_Registration_Certificate": certificate_location
                  },
                  {
                    headers: {
                      "Authorization": `Bearer ${response.data.Token}`,
                    },
                  })
              }

            } catch (e) {

            }
            setSignInLoading(false);
            setEmailVerificationFlag(4);
          }
        })

    } catch (e) {
      setSignInLoading(false);

      if (e.response) {
        if (e.response.status === 403) {
          enqueueSnackbar("Your account has been created", { variant: 'success', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });

          navigate('/sign-in')
          EventEmitter.emit("show_top_navigation", { value: false });
        } else {
          setIsInvalid(true);
        }
      }
    }
  }

  const authenticateUser = async () => {
    try {
      setSignInLoading(true);

      await axios.get(`/dwapi/users/info`, {
        headers: {
          "Authorization": `Bearer ${accessTokenLoginRef.current}`,
        },
      })
        .then(async response => {
          if (response) {
            window.localStorage.setItem('user_data', JSON.stringify(response.data));
            window.localStorage.setItem('user_token', JSON.stringify(accessTokenLoginRef.current));

            enqueueSnackbar("Login successful", { variant: 'success', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });

            setError({ ...errorRef.current, login: false })

            setTimeout(() => {
              window.location.href = '/';
            }, 2000)
          }
        })

      setSignInLoading(false);

    } catch (e) {
      setSignInLoading(false);

      if (e.response) {
        if (e.response.status === 403) {
          enqueueSnackbar("Your account has been created", { variant: 'success', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });

          navigate('/sign-in')
          EventEmitter.emit("show_top_navigation", { value: false });
        } else {
          setIsInvalid(true);
        }
      }
    }
  }

  const backToLogin = () => {
    navigate('/sign-in')
    EventEmitter.emit("show_top_navigation", { value: false });
  }

  const onChangeEmail = (e) => {
    setEmail(e);
    setError({ ...errorRef.current, email: false, emailFormat: false, error_message: '' })
    setErrorMessage('');
  }

  const checkEmailFormat = (type) => {
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (type === "email") {
      if (emailRef.current) {
        if (!emailRef.current.match(mailformat)) {
          setError({ ...errorRef.current, emailFormat: true, error_message: '' })
        } else {
          setError({ ...errorRef.current, emailFormat: false, error_message: '' })
        }
      } else {
        setError({ ...errorRef.current, emailFormat: false, error_message: '' })
      }
    } else {
      if (userDataRef.current.billing_contact_email) {
        if (!userDataRef.current.billing_contact_email.match(mailformat)) {
          setError({ ...errorRef.current, billing_contact_email_format: true, error_message: '' })
        } else {
          setError({ ...errorRef.current, billing_contact_email_format: false, error_message: '' })
        }
      } else {
        setError({ ...errorRef.current, billing_contact_email_format: false, error_message: '' })
      }
    }

  }

  const onFormEnter = (e) => {
    if (e.key === "Enter") {
      checkEmailFormat("email");
      onSubmitEmail();
    }
  }

  const onSubmitEmail = async () => {
    if (emailRef.current && !resendEmailLoadingRef.current) {
      if (!errorRef.current.emailFormat) {
        try {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);

          const token = urlParams.get('token');

          setResendEmailLoading(true);
          await axios.post(`/csapi/greenship/users/resend-email-verification?token=${token}`, {
            Email: emailRef.current
          },
            {}).then(async response => {
              if (response.status === 200) {
                setResendEmailLoading(false);
                setIsResendSuccess(true);
              }
            })
        } catch (e) {
          setResendEmailLoading(false);
          if (e.response) {
            setError({ ...errorRef.current, error_message: true })
            if (e.response.status === 403 || e.response.status === 404) {
              setIsResendSuccess(true);
            } else {
              var error_message = e.response ? e.response.data ? e.response.data ? e.response.data.Error.Message : e.response.data : e.response.statusText : e.message;
              setErrorMessage(error_message);
            }
          }
        }
      }
    } else {
      setError({ ...errorRef.current, email: true });
    }
  }

  const getErrorMessage = () => {
    var message = "Incorrect email and/or password, please try again.";
    if (errorRef.current.email) {
      message = "Email is required"
    } else if (errorRef.current.emailFormat) {
      message = "Please enter correct email format."
    } else if (errorMessageRef.current) {
      message = errorMessageRef.current;
    }

    return message;
  }

  const onChangeAddress = async (data) => {
    setSelectedAddressValue(data);
    if (data) {
      var address = data.label;
      var subpremise = '';
      var street_number = '';
      var route = '';
      var check_address = '';
      var Zip = '';
      var State = '';
      var City = '';

      setInputAddressValue(address);

      const results = await geocodeByAddress(address);

      if (results[0]) {

        /* eslint-disable array-callback-return */
        results[0].address_components.map((value) => {
          if (value.types) {
            value.types.map((types_value) => {
              if (types_value === "subpremise") {
                subpremise = "U" + value.long_name + '/';
                check_address = "U" + value.long_name + '/';
              }

              if (types_value === "street_number") {
                street_number = value.long_name + ' ';
                check_address = check_address + ' ' + value.long_name;
              }

              if (types_value === "route") {
                route = value.long_name + '';
                check_address = check_address + ' ' + value.long_name;
              }

              if (types_value === "postal_code") {
                Zip = value.long_name;
              }

              if (types_value === "administrative_area_level_1") {
                State = value.short_name;
              }

              if (types_value === "locality") {
                City = value.long_name;
              }

            })
          }
        })
        /* eslint-enable array-callback-return */
      }


      if (check_address.length <= 30) {
        setSelectedDispensaryAddress({
          ...selectedDispensaryAddressRef.current,
          Address: subpremise + '' + street_number + '' + route,
          Address2: ''
        })
      } else {
        setSelectedDispensaryAddress({
          ...selectedDispensaryAddressRef.current,
          Address: subpremise,
          Address2: street_number + ' ' + route
        })
      }

      setSelectedDispensaryAddress({
        ...selectedDispensaryAddressRef.current,
        City: City,
        State: State,
        Zip: Zip
      })

      setError({ ...errorRef.current, dispensary_address: false });
    } else {
      setInputAddressValue('');
      setError({ ...errorRef.current, dispensary_address: false });
    }
  }

  const getDispensaryAddress = () => {
    var address = "";
    var selected_address = selectedDispensaryAddressRef.current;
    if (selected_address.Address) {
      address += selected_address.Address;

      if (selected_address.Address2) {
        address += " " + selected_address.Address2;
      }

      address += ", " + selected_address.City;

      var state = selected_address.State;
      if (state) {
        var state_index = regionList.findIndex(x => x.value === state);
        if (state_index !== -1) {
          state = regionList[state_index].name;
        }
      }

      address += ", " + state;
      address += ", " + selected_address.Zip;
    }
    return address;
  }

  const onFileChange = (e) => {
    setError({ ...errorRef.current, ahpra_registration_certificate: false })
    setselectedFile(e.target.files[0])
  }

  const openTNC = () => {
    // window.open("/terms_and_conditions")
    window.open("https://dispensary.greenship.com.au/terms")
  }


  return (
    <Page title="Email Verification" className="page-container withTopNavigation">
      {loadingRef.current ?
        <LoadingView />
        :
        <>
          <div className="login-page-unsplash-desktop">
            <div className="login-page-unsplash-image-desktop"></div>
          </div>
          <div className="login-main-container">
            {isInvalidRef.current ?
              <div className="login-main-container-wrapper">
                {!isResendSuccessRef.current ?
                  <div className="login-main-container-wrapper-2" style={{ marginTop: "unset" }}>
                    <div className="help-center-container email-verification">Have a question? Visit <a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: "underline", fontWeight: "500" }}>Help Center</a></div>
                    <div className="login-container-content custom-1">
                      <div className="login-top-container">
                        <div className="login-top-container-title-wrapper">
                          <div className="login-container-sub-title">Email verification link has expired.<br />Please enter your email address and we'll send another verification link.</div>
                        </div>
                        <div className="login-form-forgot_password">
                          <div>
                            <FormControl isInvalid={errorRef.current.email || errorRef.current.emailFormat ? true : false} w="100%" maxW="100%">
                              <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Email address</div></FormControl.Label>
                              <TextboxCustom name="email_address" placeholder="Email" onChangeText={(e) => onChangeEmail(e)} backgroundColor={errorRef.current.email || errorRef.current.emailFormat ? "custom.red.2" : "white"}
                                value={emailRef.current}
                                onBlur={() => checkEmailFormat("email")}
                                onKeyPress={(e) => onFormEnter(e)}
                              />
                            </FormControl>
                          </div>
                        </div>
                      </div>
                      <div className="login-bottom-container email-verification">
                        {errorMessageRef.current || errorRef.current.email || errorRef.current.emailFormat ?
                          <div className="login-error-container">
                            <div className="login-error-container-wrapper">
                              <div className="login-error-container-text">{getErrorMessage()}</div>
                            </div>
                          </div>
                          : ""}
                        <button className={`authentication-button ${errorRef.current.email || errorRef.current.emailFormat ? "disabled" : ""}`} disabled={errorRef.current.email || errorRef.current.emailFormat} onClick={() => onSubmitEmail()}>
                          {resendEmailLoadingRef.current ? <Spinner color="white" style={{ marginRight: "8px" }} /> : ""} <div className="authentication-text">Send</div>
                        </button>
                        <div className="login-bottom-text"></div>
                      </div>
                    </div>
                    <div className="login-bottom-text support-text">
                      <div><a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: "underline", fontWeight: "500" }}>Contact Support</a></div>
                      <div style={{ minHeight: "40px" }}></div>
                    </div>

                  </div>
                  :
                  <div className="login-main-container-wrapper-2" style={{ marginTop: "unset" }}>
                    <div className="help-center-container">Have a question? Visit <a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: "underline", fontWeight: "500" }}>Help Center</a></div>
                    <div className="login-container-content custom-1">
                      <div className="login-top-container sign-up">
                        <div className="reset-password-background-2" style={{ marginTop: "108.91px" }}>
                          <div style={{ display: "flex", justifyContent: "center", paddingTop: "38px" }}>
                            <div style={{ width: "75px", height: "75px" }}>
                              <img
                                className="icons-tick"
                                style={{ maxWidth: "100%", minWidth: "100%", maxHeight: "100%", minHeight: "100%", objectFit: "cover", borderRadius: "50%", position: "center" }}
                                alt="checked"
                              />
                            </div>
                          </div>
                          <div className="reset-password-title" style={{ marginTop: "38.83px" }}>A new verification link has been sent to your email</div>
                          <div className="reset-password-sub-title">Please check your Inbox for your verification email</div>
                        </div>
                      </div>
                    </div>
                    <div></div>
                  </div>
                }
              </div>
              :
              <div className="login-main-container-wrapper">
                {/* {emailVerificationFlagRef.current === 1 ?
                  <div className="back_arrow"><i className="icon-arrow-left" style={{ fontSize: "16px" }} onClick={() => onClickBackArrow()}></i></div>
                  : ""
                } */}

                {/* register page  */}
                {emailVerificationFlagRef.current === 1 ?
                  <div className="login-main-container-wrapper-2" style={{ marginTop: "unset" }}>
                    <div className="help-center-container email-verification">Have a question? Visit <a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: "underline", fontWeight: "500" }}>Help Center</a></div>
                    <div className="login-container-content custom-1" style={{ "--height": "780px" }}>
                      <div className="login-top-container">
                        {/* <div className="login-top-container-image-wrapper">
                          <img
                            style={{ cursor: "pointer" }}
                            onClick={() => backToLogin()}
                            className="login-top-container-image"
                            src="/static/images/greenship_dispensary_logo.png"
                            alt="greenship_logo"
                          />
                        </div> */}
                        <div className="login-top-container-title-wrapper">
                          <div className="register-step-number">
                            <div className="hide-mobile"><div style={{ minHeight: "40px" }}></div></div>
                            <span style={{ color: "#DF4C6F" }}>1</span>/3</div>
                          <div className="register-container-title">
                            Your Business Details</div>
                        </div>
                        <div className="login-form">
                          <div style={{ marginTop: "37px" }}>
                            <FormControl isInvalid={errorRef.current.entity_name ? true : false} w="100%" maxW="100%">
                              <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Entity Name</div></FormControl.Label>
                              <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="entity_name" placeholder="Company name PTY LTD"
                                onChangeText={(e) => onChange(e, "entity_name")} backgroundColor={errorRef.current.entity_name ? "custom.red.2" : "white"}
                                value={userDataRef.current.entity_name}
                              />
                            </FormControl>
                          </div>

                          <div style={{ marginTop: "20px" }}>
                            <FormControl isInvalid={errorRef.current.trading_name ? true : false} w="100%" maxW="100%">
                              <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Trading Name</div></FormControl.Label>
                              <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="trading_name" placeholder="ie: Melbourne Compounding Pharmacy"
                                onChangeText={(e) => onChange(e, "trading_name")} backgroundColor={errorRef.current.trading_name ? "custom.red.2" : "white"}
                                value={userDataRef.current.trading_name}
                              />
                            </FormControl>
                          </div>

                          <div style={{ marginTop: "20px" }}>
                            <FormControl isInvalid={errorRef.current.abn ? true : false} w="100%" maxW="100%">
                              <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">ABN</div></FormControl.Label>
                              <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="abn" placeholder=""
                                onChangeText={(e) => onChange(e, "abn")} backgroundColor={errorRef.current.abn ? "custom.red.2" : "white"}
                                value={userDataRef.current.abn}
                              />
                            </FormControl>
                          </div>

                          <div style={{ marginTop: "20px" }}>
                            <FormControl isInvalid={errorRef.current.dispensary_address ? true : false} w="100%" maxW="100%">
                              <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Dispensary Address</div></FormControl.Label>

                            </FormControl>
                            <GooglePlacesAutocomplete
                              apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                              autocompletionRequest={{
                                componentRestrictions: { country: "au" },
                                types: ["address"],
                                fields: ["address_components", "geometry", "icon", "name"]
                              }}
                              selectProps={{
                                inputId: `address-input-text-register${errorRef.current.dispensary_address ? " error" : ""}`,
                                className: `select-address-autocomplete register ${errorRef.current.dispensary_address ? "error" : ""}`,
                                placeholder: "Search address...",
                                inputValue: inputAddressValueRef.current,
                                blurInputOnSelect: true,
                                onInputChange: (value, { action }) => {
                                  if (action === "input-change") {
                                    setInputAddressValue(value)
                                  }

                                },
                                controlShouldRenderValue: true,
                                onChange: (data) => {
                                  onChangeAddress(data);
                                },
                                styles: {
                                  option: (provided, { isFocused, isSelected }) => ({
                                    ...provided,
                                    background: isSelected ? "#50A453" :
                                      isFocused ? "#bbdfbe" : "white",
                                  })
                                },
                                value: selectedAddressValueRef.current,
                                isClearable: true,
                                getOptionLabel: (value) => {
                                  var label_value_main = "";
                                  var label_value_secondary = "";

                                  if (value.value) {
                                    if (value.value.structured_formatting) {
                                      if (value.value.structured_formatting.main_text) {
                                        label_value_main = value.value.structured_formatting.main_text;
                                      }

                                      if (value.value.structured_formatting.secondary_text) {
                                        label_value_secondary = value.value.structured_formatting.secondary_text;
                                      }
                                    }
                                  }
                                  return <div className="address-input-wrapper">
                                    <div style={{ marginTop: "3px" }}><PlaceIcon className="place-icon-address" /></div>
                                    <div><span style={{ fontSize: "14px" }}>{label_value_main}</span><span style={{ fontSize: "12px" }}>, {label_value_secondary}</span></div>
                                  </div>
                                }
                              }}
                            />
                            <div style={{ marginTop: "10px" }}>
                              <div className="dispensary_address-container">
                                {getDispensaryAddress()}
                              </div>
                            </div>
                          </div>
                          <div style={{ marginTop: "20px" }}>
                            <FormControl isInvalid={errorRef.current.primary_contact_name ? true : false} w="100%" maxW="100%">
                              <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Primary Contact Name</div></FormControl.Label>
                              <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="primary_contact_name" placeholder=""
                                onChangeText={(e) => onChange(e, "primary_contact_name")} backgroundColor={errorRef.current.primary_contact_name ? "custom.red.2" : "white"}
                                value={userDataRef.current.primary_contact_name}
                              />
                            </FormControl>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div>
                      <div className="login-bottom-container email-verification">
                        {(errorRef.current.entity_name || errorRef.current.trading_name || errorRef.current.abn
                          || errorRef.current.dispensary_address || errorRef.current.primary_contact_name) ?
                          <div className="center_container" style={{ marginBottom: "12px", marginTop: "16px" }}>
                            <div className="register-error-container">
                              <div className="register-error-container-wrapper">
                                <div className="register-error-container-text">
                                  You must fill in all of the fields.
                                </div>
                              </div>
                            </div>
                          </div>
                          : <div style={{ minHeight: "50px", marginBottom: "12px", marginTop: "16px" }}></div>}
                        <button className={`authentication-button ${errorRef.current.entity_name || errorRef.current.trading_name || errorRef.current.abn || errorRef.current.dispensary_address || errorRef.current.primary_contact_name ? "disabled" : ""}`} onClick={() => onSubmit()} disabled={signInLoadingRef.current} >
                          {signInLoadingRef.current ? <Spinner color="white" style={{ marginRight: "8px" }} /> : ""}<div className="authentication-text">Next</div>
                        </button>
                      </div>
                      <div className="login-bottom-text support-text">
                        <div><a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: 'underline', fontWeight: "500" }}>Contact Support</a></div>
                        <div style={{ minHeight: "30px" }}></div>
                      </div>
                    </div>
                  </div>
                  : emailVerificationFlagRef.current === 2 ?
                    <div className="login-main-container-wrapper-2" style={{ marginTop: "unset" }}>
                      <div className="help-center-container email-verification">Have a question? Visit <a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: "underline", fontWeight: "500" }}>Help Center</a></div>
                      <div className="login-container-content custom-1" style={{ "--height": "780px" }}>
                        <div className="login-top-container">
                          <div className="login-top-container-title-wrapper">
                            <div className="register-step-number">
                              <div className="hide-mobile" style={{ marginBottom: "10px" }}><div className="register-top-navigation" onClick={() => onClickBackArrow()}><ArrowBackRoundedIcon style={{ marginRight: "10px", fontSize: "20px", marginTop: "-3px" }} />Back</div></div>
                              <span style={{ color: "#DF4C6F" }}>2</span>/3</div>
                            <div className="register-container-title">
                              Your Contact Details</div>
                          </div>
                          <div className="login-form">
                            <div style={{ marginTop: "37px" }}>
                              <FormControl isInvalid={errorRef.current.primary_contact_email ? true : false} w="100%" maxW="100%">
                                <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Primary Contact Email</div></FormControl.Label>
                                <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="primary_contact_email" placeholder=""
                                  isDisabled={true} backgroundColor={errorRef.current.primary_contact_email ? "custom.red.2" : "white"}
                                  value={userDataRef.current.primary_contact_email}
                                />
                              </FormControl>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                              <FormControl isInvalid={errorRef.current.primary_contact_phone ? true : false} w="100%" maxW="100%">
                                <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Primary Contact Phone</div></FormControl.Label>
                                <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="primary_contact_phone" placeholder=""
                                  onChangeText={(e) => onChange(e, "primary_contact_phone")} backgroundColor={errorRef.current.primary_contact_phone ? "custom.red.2" : "white"}
                                  value={userDataRef.current.primary_contact_phone}
                                />
                              </FormControl>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                              <FormControl isInvalid={errorRef.current.lead_pharmacist_ahpra_number ? true : false} w="100%" maxW="100%">
                                <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Lead Pharmacist AHPRA Number</div></FormControl.Label>
                                <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="lead_pharmacist_ahpra_number" placeholder=""
                                  onChangeText={(e) => onChange(e, "lead_pharmacist_ahpra_number")} backgroundColor={errorRef.current.lead_pharmacist_ahpra_number ? "custom.red.2" : "white"}
                                  value={userDataRef.current.lead_pharmacist_ahpra_number}
                                />
                              </FormControl>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                              <FormControl isInvalid={errorRef.current.ahpra_registration_certificate ? true : false} w="100%" maxW="100%">
                                <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title"><span style={{ color: "#EA4F4F" }}>*</span>AHPRA Registration Certificate </div></FormControl.Label>
                                <div className={`upload_certificate-container ${selectedFileRef.current ? "replace" : ""}`} style={{ position: "relative" }}>

                                  <input id="getFile1" type="file" style={{ opacity: "0", position: "absolute", top: "0", left: "0", right: "0", width: "100%", height: "100%", cursor: "pointer" }} onChange={(e) => onFileChange(e)} />
                                  <div className="upload_certificate-container-text">{selectedFileRef.current ? "Replace" : "Upload a certificate"}</div>
                                </div>
                                {selectedFileRef.current ? <div style={{ color: "#202020", fontSize: "12px", marginTop: "5px" }}>{selectedFileRef.current.name}</div> : ""}
                                {errorRef.current.ahpra_registration_certificate ? <div style={{ color: "rgb(239, 68, 68)", fontSize: "12px", marginTop: "5px" }}>Please upload the certificate</div> : ""}
                              </FormControl>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                              <FormControl isInvalid={errorRef.current.billing_contact_name ? true : false} w="100%" maxW="100%">
                                <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Billing Contact Name</div></FormControl.Label>
                                <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="billing_contact_name" placeholder=""
                                  onChangeText={(e) => onChange(e, "billing_contact_name")} backgroundColor={errorRef.current.billing_contact_name ? "custom.red.2" : "white"}
                                  value={userDataRef.current.billing_contact_name}
                                />
                              </FormControl>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                              <FormControl isInvalid={errorRef.current.billing_contact_phone ? true : false} w="100%" maxW="100%">
                                <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Billing Contact Phone</div></FormControl.Label>
                                <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="billing_contact_phone" placeholder=""
                                  onChangeText={(e) => onChange(e, "billing_contact_phone")} backgroundColor={errorRef.current.billing_contact_phone ? "custom.red.2" : "white"}
                                  value={userDataRef.current.billing_contact_phone}
                                />
                              </FormControl>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                              <FormControl isInvalid={errorRef.current.billing_contact_email || errorRef.current.billing_contact_email_format ? true : false} w="100%" maxW="100%">
                                <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Billing Contact Email</div></FormControl.Label>
                                <TextboxCustom h="36px" placeholderTextColor="custom.grey.15" name="billing_contact_email" placeholder=""
                                  onChangeText={(e) => onChange(e, "billing_contact_email")} backgroundColor={errorRef.current.billing_contact_email || errorRef.current.billing_contact_email_format ? "custom.red.2" : "white"}
                                  value={userDataRef.current.billing_contact_email}
                                />
                              </FormControl>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div className="login-bottom-container email-verification">
                          {(errorRef.current.primary_contact_email || errorRef.current.primary_contact_phone || errorRef.current.lead_pharmacist_ahpra_number || errorRef.current.ahpra_registration_certificate
                            || errorRef.current.billing_contact_name || errorRef.current.billing_contact_email || errorRef.current.billing_contact_phone || errorRef.current.billing_contact_email_format) ?
                            <div className="center_container" style={{ marginBottom: "12px", marginTop: "16px" }}>
                              <div className="register-error-container">
                                <div className="register-error-container-wrapper">
                                  <div className="register-error-container-text">
                                    {(errorRef.current.primary_contact_email || errorRef.current.primary_contact_phone || errorRef.current.lead_pharmacist_ahpra_number || errorRef.current.ahpra_registration_certificate
                                      || errorRef.current.billing_contact_name || errorRef.current.billing_contact_email || errorRef.current.billing_contact_phone) ? <div>You must fill in all of the fields.</div> : ""}
                                    {errorRef.current.billing_contact_email_format ? "Please enter correct email format." : ""}

                                  </div>
                                </div>
                              </div>
                            </div>
                            : <div style={{ minHeight: "48px", marginBottom: "12px", marginTop: "16px" }}></div>}
                          <button className={`authentication-button ${errorRef.current.primary_contact_email || errorRef.current.primary_contact_phone || errorRef.current.lead_pharmacist_ahpra_number || errorRef.current.ahpra_registration_certificate
                            || errorRef.current.billing_contact_name || errorRef.current.billing_contact_email || errorRef.current.billing_contact_phone || errorRef.current.billing_contact_email_format ? "disabled" : ""}`} onClick={() => onSubmit()} disabled={signInLoadingRef.current} >
                            {signInLoadingRef.current ? <Spinner color="white" style={{ marginRight: "8px" }} /> : ""}<div className="authentication-text">Next</div>
                          </button>
                        </div>
                        <div className="login-bottom-text support-text">
                          <div><a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: "underline", fontWeight: "500" }}>Contact Support</a></div>
                          <div style={{ minHeight: "30px" }}></div>
                        </div>
                      </div>
                    </div>
                    : emailVerificationFlagRef.current === 3 ?
                      <div className="login-main-container-wrapper-2" style={{ marginTop: "unset" }}>
                        <div className="help-center-container email-verification">Have a question? Visit <a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: "underline", fontWeight: "500" }}>Help Center</a></div>
                        <div className="login-container-content custom-1" style={{ "--height": "780px" }}>
                          <div className="login-top-container">
                            {/* <div className="login-top-container-image-wrapper">
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={() => backToLogin()}
                              className="login-top-container-image"
                              src="/static/images/greenship_dispensary_logo.png"
                              alt="greenship_logo"
                            />
                          </div> */}
                            <div className="login-top-container-title-wrapper">
                              <div className="register-step-number">
                                <div className="hide-mobile" style={{ marginBottom: "10px" }}><div className="register-top-navigation" onClick={() => onClickBackArrow()}><ArrowBackRoundedIcon style={{ marginRight: "10px", fontSize: "20px", marginTop: "-3px" }} />Back</div></div>
                                <span style={{ color: "#DF4C6F" }}>3</span>/3</div>
                              <div className="register-container-title">
                                Your Contact Details</div>
                            </div>
                            <div className="login-form">
                              <div style={{ marginTop: "37px" }}>
                                <FormControl isInvalid={errorRef.current.primary_contact_email ? true : false} w="100%" maxW="100%">
                                  <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">Are you a compounding pharmacy?</div></FormControl.Label>
                                </FormControl>
                                <div className="register-select-wrapper">
                                  <button className={`register-select-item ${userDataRef.current.are_you_a_compounding_pharmacy === 1 ? "selected" : ""}`}
                                    onClick={() => { setUserData({ ...userDataRef.current, are_you_a_compounding_pharmacy: 1 }); setError({ ...errorRef.current, are_you_a_compounding_pharmacy: false }); }}
                                  >Yes</button>
                                  <button className={`register-select-item ${userDataRef.current.are_you_a_compounding_pharmacy === 2 ? "selected" : ""}`}
                                    onClick={() => { setUserData({ ...userDataRef.current, are_you_a_compounding_pharmacy: 2 }); setError({ ...errorRef.current, are_you_a_compounding_pharmacy: false }); }}
                                  >No</button>
                                </div>
                                {errorRef.current.are_you_a_compounding_pharmacy ? <div style={{ color: "rgb(239, 68, 68)", fontSize: "12px", marginTop: "5px" }}>You must select one of these options.</div> : ""}
                              </div>

                              <div style={{ marginTop: "20px" }}>
                                <FormControl isInvalid={errorRef.current.what_type_of_pharmacy_are_you ? true : false} w="100%" maxW="100%">
                                  <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">What type of pharmacy are you?</div></FormControl.Label>
                                  <Select
                                    displayEmpty
                                    className={errorRef.current.what_type_of_pharmacy_are_you ? (classes.select + " " + classes.select_error) : classes.select}
                                    value={userDataRef.current.what_type_of_pharmacy_are_you ? userDataRef.current.what_type_of_pharmacy_are_you : ""}
                                    onChange={(e) => onChange(e, "what_type_of_pharmacy_are_you")}
                                    MenuProps={{ classes: { paper: classes.menu_style } }}
                                  >
                                    <MenuItem disabled value="">
                                      <span style={{ color: "#7f8799" }}>Select</span>
                                    </MenuItem>
                                    {pharmacyTypes.map((value, index) => {
                                      return <MenuItem key={index} value={value}>{value}</MenuItem>
                                    })}
                                  </Select>
                                </FormControl>
                              </div>

                              <div style={{ marginTop: "20px" }}>
                                <FormControl isInvalid={errorRef.current.what_is_your_pharmacies_exposure_to_medical_cannabis ? true : false} w="100%" maxW="100%">
                                  <FormControl.Label style={{ marginBottom: "8px", marginTop: "0px" }}><div className="login-textbox-title">What is your pharmacies exposure to medicinal cannabis?</div></FormControl.Label>
                                  <Select
                                    displayEmpty
                                    className={errorRef.current.what_is_your_pharmacies_exposure_to_medical_cannabis ? (classes.select + " " + classes.select_error) : classes.select}
                                    value={userDataRef.current.what_is_your_pharmacies_exposure_to_medical_cannabis ? userDataRef.current.what_is_your_pharmacies_exposure_to_medical_cannabis : ""}
                                    onChange={(e) => onChange(e, "what_is_your_pharmacies_exposure_to_medical_cannabis")}
                                    MenuProps={{ classes: { paper: classes.menu_style } }}
                                  >
                                    <MenuItem disabled value="">
                                      <span style={{ color: "#7f8799" }}>Select</span>
                                    </MenuItem>
                                    {pharmacyExposure.map((value, index) => {
                                      return <MenuItem key={index} value={value}>{value}</MenuItem>
                                    })}
                                  </Select>
                                </FormControl>
                              </div>


                            </div>
                          </div>

                        </div>
                        <div>
                          <div className="login-bottom-container email-verification">
                            {(errorRef.current.what_type_of_pharmacy_are_you || errorRef.current.what_is_your_pharmacies_exposure_to_medical_cannabis) ?
                              <div className="center_container" style={{ marginBottom: "12px", marginTop: "16px" }}>
                                <div className="register-error-container">
                                  <div className="register-error-container-wrapper">
                                    <div className="register-error-container-text">
                                      You must fill in all of the fields.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              : <div style={{ minHeight: "48px", marginBottom: "12px", marginTop: "16px" }}></div>}
                            <div className="login-bottom-text-2">By clicking "Create Account", I agree to <span className="login-bottom-sub-text" onClick={() => openTNC()}> Terms and Conditions.</span></div>
                            <button className={`authentication-button ${errorRef.current.what_type_of_pharmacy_are_you || errorRef.current.what_is_your_pharmacies_exposure_to_medical_cannabis ? "disabled" : ""}`} onClick={() => onSubmit()} disabled={signInLoadingRef.current} >
                              {signInLoadingRef.current ? <Spinner color="white" style={{ marginRight: "8px" }} /> : ""}<div className="authentication-text">Create Account</div>
                            </button>
                          </div>
                          <div className="login-bottom-text support-text">
                            <div><a href={process.env.REACT_APP_CHATBOT} target="_blank" rel="noopener noreferrer" style={{ color: "#DF4C6F", textDecoration: "underline", fontWeight: "500" }}>Contact Support</a></div>
                            <div style={{ minHeight: "30px" }}></div>
                          </div>
                        </div>
                      </div>
                      : emailVerificationFlagRef.current === 4 ?
                        <div className="login-main-container-wrapper-2" style={{ marginTop: "unset" }}>
                          <div className="help-center-container"></div>
                          <div className="login-container-content custom-1" style={{ "--height": "780px" }}>
                            <div className="login-top-container sign-up">
                              <div className="reset-password-background-2">
                                <div style={{ display: "flex", justifyContent: "center", paddingTop: "38px" }}>
                                  <div style={{ width: "75px", height: "75px" }}>
                                    <img
                                      className="icons-tick"
                                      style={{ maxWidth: "100%", minWidth: "100%", maxHeight: "100%", minHeight: "100%", objectFit: "cover", borderRadius: "50%", position: "center" }}
                                      alt="checked"
                                    />
                                  </div>
                                </div>
                                <div className="reset-password-title" style={{ marginTop: "48.51px" }}>Hooray! Your account is Created!</div>
                                <div className="reset-password-sub-title">Now, let’s put that spring back in your step!</div>
                              </div>
                            </div>
                            <div className="login-bottom-container" style={{ marginTop: "109.01" }}>
                              <button className="authentication-button" onClick={() => onSubmit()} disabled={signInLoading} >
                                {signInLoading ? <Spinner color="white" style={{ marginRight: "8px" }} /> : ""}<div className="authentication-text">Let’s Go</div>
                              </button>
                              <div className="login-bottom-text" style={{ height: "34px" }}></div>
                            </div>
                          </div>
                          <div></div>
                        </div>
                        : ''
                }
              </div>
            }
          </div>
        </>
      }
    </Page >
  );
};

export default EmailVerificationView;
